import { Link } from "react-router-dom";

export default function BrandBand() {
  return (
    <section aria-labelledby="brand-heading" className="bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="overflow-hidden rounded-lg bg-secondary-900 px-6 py-10 md:px-12 md:py-14">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-7">
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-400">关于看料88</p>
              <h2
                id="brand-heading"
                className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl"
              >
                不追一时吵闹，只做经得起回看的话题存档
              </h2>
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
                我们相信，单个事件容易被情绪放大，只有把时间线拉长，话题真正的走向才会浮现。因此看料88
                只做一件事：把公开信息整理成可回看的存档，保留时间、分类与来源逻辑，让每一次回顾都有据可循。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  了解我们的内容原则
                </Link>
                <Link
                  to="/archive"
                  className="whitespace-nowrap rounded-full border border-background-50/25 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  浏览往期存档
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5">
              <ul className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
                {[
                  { icon: "ri-time-line", title: "时间线归档", desc: "按发布时间排序，话题先后一目了然。" },
                  { icon: "ri-shield-check-line", title: "公开信息为准", desc: "只做现象梳理，不做未经证实的指控。" },
                  { icon: "ri-links-line", title: "来源可回溯", desc: "每篇盘点都标注讨论范围与时间节点。" },
                ].map((item) => (
                  <li key={item.title} className="flex items-start gap-3 rounded-lg bg-background-50/5 p-4">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background-50/10 text-accent-400">
                      <i className={item.icon} />
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-background-50">{item.title}</span>
                      <span className="mt-1 block text-xs leading-relaxed text-background-300">{item.desc}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}